// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"f5b795c2","260":"ac009773","541":"3993a1c8","666":"45100609","965":"6b872ebc"}[chunkId] + ".css";
};